import { defineStore } from 'pinia'

const numberWords = [
	'zero', 'one', 'two', 'three', 'four', 'five',
	'six', 'seven', 'eight', 'nine'
]

function loadPending() {
	try {
		const raw = localStorage.getItem('pendingStoryApprovals')
		return raw ? JSON.parse(raw) : []
	} catch {
		return []
	}
}

export function childAgeYears(birthDateIso) {
	if (!birthDateIso) return null
	const d = new Date(birthDateIso + (birthDateIso.length === 10 ? 'T12:00:00' : ''))
	if (Number.isNaN(d.getTime())) return null
	const today = new Date()
	let years = today.getFullYear() - d.getFullYear()
	const m = today.getMonth() - d.getMonth()
	if (m < 0 || (m === 0 && today.getDate() < d.getDate())) years--
	return Math.max(0, years)
}

export const useSettingsStore = defineStore('settings', {
	state: () => ({
		accessCode: null,
		openAIKey: localStorage.getItem('openAIKey') || '',
		childBirthDate: localStorage.getItem('childBirthDate') || '',
		pendingApprovals: loadPending()
	}),

	getters: {
		accessCodeAsWords: (state) => {
			if (!state.accessCode) return ''
			return state.accessCode.split('').map(digit => numberWords[parseInt(digit)]).join(' ')
		},
		childAgeYears: (state) => childAgeYears(state.childBirthDate)
	},

	actions: {
		generateAccessCode() {
			const code = Math.floor(1000 + Math.random() * 9000).toString()
			this.accessCode = code
			return code
		},

		validateAccessCode(inputCode) {
			return inputCode === this.accessCode
		},

		setOpenAIKey(key) {
			this.openAIKey = key
			localStorage.setItem('openAIKey', key)
		},

		setChildBirthDate(isoDate) {
			this.childBirthDate = isoDate || ''
			if (isoDate) localStorage.setItem('childBirthDate', isoDate)
			else localStorage.removeItem('childBirthDate')
		},

		_persistPending() {
			localStorage.setItem('pendingStoryApprovals', JSON.stringify(this.pendingApprovals))
		},

		addPendingApproval(entry) {
			this.pendingApprovals = [
				{ ...entry, createdAt: entry.createdAt || new Date().toISOString() },
				...this.pendingApprovals.filter(p => p.id !== entry.id)
			]
			this._persistPending()
		},

		removePendingApproval(id) {
			const idx = this.pendingApprovals.findIndex(p => p.id === id)
			if (idx === -1) return false
			this.pendingApprovals.splice(idx, 1)
			this._persistPending()
			return true
		},

		rejectPendingApproval(id) {
			this.removePendingApproval(id)
		}
	}
})
